import React from 'react';
import { CustomerContact } from '../../../types/customer-contact';
import { Customer } from '../../../types';
import { formatAddress } from '../utils/contactHelpers';

interface ContactViewPanelProps {
  selectedContact: CustomerContact;
  customers: Customer[];
  panelError: string | null;
}

const ContactViewPanel: React.FC<ContactViewPanelProps> = ({
  selectedContact,
  customers,
  panelError,
}) => (
  <div className="space-y-3">
    {panelError && (
      <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded text-sm">
        {panelError}
      </div>
    )}

    <div className="rounded-xl theme-border theme-card p-3">
      <label className="block text-sm font-medium theme-text-secondary mb-0.5">Name</label>
      <p className="text-sm theme-text-primary font-medium">{selectedContact.name}</p>
    </div>

    <div className="grid grid-cols-2 gap-3">
      <div className="rounded-xl theme-border theme-card p-3">
        <label className="block text-sm font-medium theme-text-secondary mb-0.5">Customer</label>
        <p className="text-sm theme-text-primary">
          {customers.find((c) => c.id === selectedContact.customer_id)?.item || '-'}
        </p>
      </div>
      <div className="rounded-xl theme-border theme-card p-3">
        <label className="block text-sm font-medium theme-text-secondary mb-0.5">Title</label>
        <p className="text-sm theme-text-primary">{selectedContact.title || '-'}</p>
      </div>
    </div>

    <div className="grid grid-cols-2 gap-3">
      <div className="rounded-xl theme-border theme-card p-3">
        <label className="block text-sm font-medium theme-text-secondary mb-0.5">Email</label>
        {selectedContact.email ? (
          <a href={`mailto:${selectedContact.email}`} className="text-blue-600 hover:text-blue-800 text-sm">
            {selectedContact.email}
          </a>
        ) : (
          <p className="text-sm theme-text-tertiary">-</p>
        )}
      </div>
      <div className="rounded-xl theme-border theme-card p-3">
        <label className="block text-sm font-medium theme-text-secondary mb-0.5">Phone</label>
        {selectedContact.phone ? (
          <a href={`tel:${selectedContact.phone}`} className="text-blue-600 hover:text-blue-800 text-sm">
            {selectedContact.phone}
          </a>
        ) : (
          <p className="text-sm theme-text-tertiary">-</p>
        )}
      </div>
    </div>

    <div className="rounded-xl theme-border theme-card p-3">
      <label className="block text-sm font-medium theme-text-secondary mb-0.5">Address</label>
      <p className="text-sm theme-text-primary">{formatAddress(selectedContact)}</p>
    </div>

    {selectedContact.notes && (
      <div className="rounded-xl theme-border theme-card p-3">
        <label className="block text-sm font-medium theme-text-secondary mb-0.5">Notes</label>
        <p className="text-sm theme-text-primary whitespace-pre-wrap">{selectedContact.notes}</p>
      </div>
    )}

    <div className="rounded-xl theme-border theme-card p-3">
      <label className="block text-sm font-medium theme-text-secondary mb-0.5">Primary Contact</label>
      <span
        className={`inline-flex px-2 py-0.5 text-sm font-semibold rounded-full ${
          selectedContact.is_primary ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'
        }`}
      >
        {selectedContact.is_primary ? 'Yes' : 'No'}
      </span>
    </div>
  </div>
);

export default ContactViewPanel;
